import React, { RefObject } from 'react';
import { ScrollView, StyleSheet, View, ViewProps } from 'react-native';

import AssessmentListSectionItem from './AssessmentListSectionItem';
import { CoachInfo } from 'src/core/types/CoachInfo';
import { HealthMarkerGroup } from 'src/core/types/HealthMarkerReport';
import CoachMessage from './CoachMessage';
import { UIHelper as uh } from 'src/core';
import { Layout } from '@ui-kitten/components';

//props
interface AssessmentListSectionProps extends ViewProps {
  btnDetailAssessmentClick: (assessmentId: string) => void;
  sections: HealthMarkerGroup[];
  groupComment?: string;
  coach: CoachInfo;
  scrollRef: RefObject<ScrollView>;
}

const AssessmentListSection = ({
  btnDetailAssessmentClick,
  sections,
  groupComment,
  coach,
  scrollRef
}: AssessmentListSectionProps) => {
  const styleContainer = StyleSheet.create({
    container: {
      borderRadius: 8
    },
    messagecontainer: {
      marginTop: uh.w2DP(24),
      borderRadius: 8
    },
    coachMessage: {
      marginTop: uh.h2DP(16),
      marginLeft: uh.w2DP(16),
      marginRight: uh.w2DP(16),
      marginBottom: uh.h2DP(16)
    }
  });

  const renderSections = () => {
    return sections.map((section, index) => {
      return (
        <AssessmentListSectionItem
          btnDetailAssessmentClick={btnDetailAssessmentClick}
          key={`ListSectionItem-${index}`}
          section={section}
          coach={coach}
          scrollRef={scrollRef}
        />
      );
    });
  };

  return (
    <View style={styleContainer.container}>
      {renderSections()}
      <Layout style={styleContainer.messagecontainer}>
        {groupComment && groupComment.length > 0 && (
          <CoachMessage style={styleContainer.coachMessage} messages={[groupComment as string]} coach={coach} />
        )}
      </Layout>
    </View>
  );
};

export default AssessmentListSection;
